module.exports = __webpack_public_path__ + "media/packs/images/flags/UG-1835a846ff9f5630a7ed31a861382481.png";